import { useEffect } from 'react'
import { BrowserRouter } from 'react-router-dom'
import AppRoutes from './AppRoutes'
import { useAuthStore } from './store/authStore'
import ErrorBoundary from './components/ErrorBoundary'
import ToastContainer from './components/Toast'
import client from './api/client'

function AuthInit() {
  const { isAuthenticated, user, setUser, logout } = useAuthStore()
  useEffect(() => {
    if (isAuthenticated && !user) {
      client.get('/users/me')
        .then((r) => setUser(r.data))
        .catch(() => logout())
    }
  }, [])
  return null
}

export default function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <AuthInit />
        <AppRoutes />
      </BrowserRouter>
      <ToastContainer />
    </ErrorBoundary>
  )
}
